import React from 'react'
import Header from "../components/headers/light.js"
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Breadcrumb from "components/breadcrumbs/Breadcrumb.jsx";
import { Outlet } from 'react-router-dom';
import tw from "twin.macro";

const ContentContainer = tw.div`pt-12 md:pt-10`;

const MainLayout = () => {
    return (
        <div>
            <Header />
            <Breadcrumb />
            <ContentContainer>
                <Outlet />
            </ContentContainer>
            <Footer />
        </div>
    )
}

export default MainLayout
